import * as keyResourceApi from "./keyResource";
import * as locationApi from "./location";
import * as remedyApi from "./remedy";
import * as userApi from "./user";

const services = {
  getRemedyList: remedyApi.getList,
  getRemedy: remedyApi.getItem,
  postRemedy: remedyApi.addItem,
  postEditRemedy: remedyApi.editItem,

  getLocationList: locationApi.getList,
  getAllLocationResourceList: locationApi.getAllList,
  getLocationResourceList: locationApi.getItem,
  getLocationResourceItem: locationApi.getRes,
  postLocationResource: locationApi.addItem,
  postEditLocationResource: locationApi.editItem,

  getKeyResourceList: keyResourceApi.getList,
  getKeyResourceItem: keyResourceApi.getRes,
  postKeyResource: keyResourceApi.addItem,
  postEditKeyResource: keyResourceApi.editItem,

  performLogin: userApi.login,
  getUser: userApi.getUser,
  deleteUser: userApi.delUser,
  getAllUser: userApi.getList,
  registerUser: userApi.register,
  rootRegisterUser: userApi.rootRegister,
};

export default services;
